"use client";
import Image from "next/image";
import SectionTitle from "../Common/SectionTitle";
import aboutLightImage from "../../public/images/project/pic-5-2.svg";
import aboutDarkImage from "../../public/images/project/pic5.svg";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

const checkIcon = (
  <svg width="16" height="13" viewBox="0 0 16 13" className="fill-current">
    <path d="M5.8535 12.6631C5.65824 12.8584 5.34166 12.8584 5.1464 12.6631L0.678505 8.1952C0.483242 7.99994 0.483242 7.68336 0.678505 7.4881L2.32921 5.83739C2.52467 5.64193 2.84166 5.64216 3.03684 5.83791L5.14622 7.95354C5.34147 8.14936 5.65859 8.14952 5.85403 7.95388L13.3797 0.420561C13.575 0.22513 13.8917 0.225051 14.087 0.420383L15.7381 2.07143C15.9333 2.26669 15.9333 2.58327 15.7381 2.77854L5.8535 12.6631Z" />
  </svg>
);

const AboutSectionOne = () => {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const List = ({ text }) => (
    <p
      id={"about"}
      className="mb-5 flex items-center text-lg font-medium text-body-color"
    >
      <span className="mr-4 flex h-[30px] w-[30px] items-center justify-center rounded-md bg-opacity-10 text-primary">
        {checkIcon}
      </span>
      {text}
    </p>
  );

  return (
    <section id="about" className="pt-16 md:pt-20 lg:pt-28">
      <div className="container">
        <div className="pb-16 md:pb-20 lg:pb-28">
          <div className="-mx-4 flex flex-wrap items-center">
            <div className="w-full px-4 lg:w-1/2">
              <SectionTitle
                title="About Yardstick"
                paragraph="Yardstick is at the forefront of digital solutions, specializing in Shopify App building, Facebook API for marketing, WhatsApp Business API, and AI development services."
                mb="44px"
              />

              <div
                className="wow fadeInUp mb-12 max-w-[570px] lg:mb-0"
                data-wow-delay=".15s"
              >
                <div className="mx-[-12px] flex flex-wrap">
                  <div className="w-full px-3">
                    <List text="We create custom Shopify apps to enhance your Shopify store and maximize eCommerce growth." />
                    <List text="We leverage Facebook API and WhatsApp Business to boost engagement and unlock new opportunities." />
                    <List text="Our AI development services transform data into intelligent actions, automating processes and delivering real value." />
                  </div>
                </div>
              </div>
              <div
                className={
                  "text-base !leading-relaxed text-body-color md:text-lg"
                }
              >
                Choose Yardstick and lead your industry with tech that
                accelerates growth, boosts engagement, and transforms
                possibilities into reality.
              </div>
            </div>

            {mounted && (
              <div className="flex w-full flex-wrap items-center justify-center px-4 lg:w-1/2">
                {theme !== "dark" ? (
                  <Image src={aboutLightImage} alt="About Image" />
                ) : (
                  <Image src={aboutDarkImage} alt="About Image" />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSectionOne;
